import { AccordionCustom } from "@/components/AccordionCustom";
import { Stack, Typography } from "@mui/material";

import { PartnerAccumulationDoubtProps } from "./types";

export const PartnerAccumulationDoubt: React.FC<PartnerAccumulationDoubtProps> = ({ title, description, listQuestionsAnswer }) => {
  if (listQuestionsAnswer.length < 1) {
    return null;
  }

  return (
    <Stack
      position="relative"
      zIndex={2}
      mt={{ xs: 0, md: -8 }}
      pt={{ xs: 6, md: 12 }}
      px={{ xs: 3, md: 4, lg: 10 }}
      gap={{ xs: 1, md: 2 }}
      justifyContent="center"
      alignItems={{ xs: "left", md: "center" }}
      bgcolor="#ffffff"
    >
      <Typography fontSize={{ xs: 24, md: 32 }} fontWeight={600}>
        {title || "Ficou alguma dúvida?"}
      </Typography>
      <Typography fontSize={16} fontWeight={400} color="#58595B">
        {description}
      </Typography>

      <Stack mt={{ xs: 6, md: "46px" }} mb={14} gap="10px" width="100%">
        {listQuestionsAnswer?.map((item) => (
          <AccordionCustom
            key={item.id}
            question={item.question}
            answer={item.answer}
            answerMedia={item.answerMedia}
            answerMediaType={item.answerMediaType}
          />
        ))}
      </Stack>
    </Stack>
  );
};
